var _defs, _path, _polygon, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10, _rect11, _rect12, _rect13, _rect14, _path2, _path3, _rect15, _rect16, _rect17, _rect18;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmailIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ed6fe6be-161b-4b6a-afb7-ec711574c2b9",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 569.5 731.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".b2b6a47c-0e99-490b-b268-532113f1b55c{fill:#fff;}.e6681b93-ebe2-46ee-89b7-7b707f740327{fill:#091b2d;}.a32d186a-4802-4999-8fac-f061c6a10df2{fill:#00a587;stroke:#00a587;}.a32d186a-4802-4999-8fac-f061c6a10df2,.f8b7cb8f-969f-4585-9d41-90df3a44c739{stroke-miterlimit:10;}.f3e9da04-6706-4360-be55-d2243af45fe4{fill:#ebeded;}.f43665e5-728f-4c4e-9ddf-efdb99fd05f3{fill:#b0b0b0;}.e7749cba-7b26-4614-a9f2-737238dba3f9{fill:#0c294c;}.f8b7cb8f-969f-4585-9d41-90df3a44c739{fill:#123466;stroke:#123466;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b2b6a47c-0e99-490b-b268-532113f1b55c",
    d: "M614.1,63.2A11.2,11.2,0,1,1,602.9,52,11.2,11.2,0,0,1,614.1,63.2Z",
    transform: "translate(-75.7 -52)"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "e6681b93-ebe2-46ee-89b7-7b707f740327",
    points: "297.6 98.5 558.6 311.5 296.6 536.2 36.6 311.5 297.6 98.5"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a32d186a-4802-4999-8fac-f061c6a10df2",
    x: 71.7,
    y: 146.1,
    width: 450.3,
    height: 24.06
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "f3e9da04-6706-4360-be55-d2243af45fe4",
    x: 71.7,
    y: 170.2,
    width: 450.3,
    height: 433.86
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "f43665e5-728f-4c4e-9ddf-efdb99fd05f3",
    x: 110.5,
    y: 290.2,
    width: 168.7,
    height: 10.24
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "f43665e5-728f-4c4e-9ddf-efdb99fd05f3",
    x: 110.5,
    y: 264.2,
    width: 168.7,
    height: 10.24
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "f43665e5-728f-4c4e-9ddf-efdb99fd05f3",
    x: 110.5,
    y: 195.2,
    width: 168.7,
    height: 53.24
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "f43665e5-728f-4c4e-9ddf-efdb99fd05f3",
    x: 110.5,
    y: 332,
    width: 372.8,
    height: 10.23
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "f43665e5-728f-4c4e-9ddf-efdb99fd05f3",
    x: 110.5,
    y: 355.3,
    width: 372.8,
    height: 10.24
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: "f43665e5-728f-4c4e-9ddf-efdb99fd05f3",
    x: 110.5,
    y: 378.6,
    width: 372.8,
    height: 10.23
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    className: "f43665e5-728f-4c4e-9ddf-efdb99fd05f3",
    x: 110.5,
    y: 401.9,
    width: 372.8,
    height: 10.24
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    className: "f43665e5-728f-4c4e-9ddf-efdb99fd05f3",
    x: 110.5,
    y: 425.2,
    width: 372.8,
    height: 10.24
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    className: "f43665e5-728f-4c4e-9ddf-efdb99fd05f3",
    x: 110.5,
    y: 448.4,
    width: 372.8,
    height: 10.24
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    className: "f43665e5-728f-4c4e-9ddf-efdb99fd05f3",
    x: 110.5,
    y: 471.7,
    width: 372.8,
    height: 10.23
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    className: "f43665e5-728f-4c4e-9ddf-efdb99fd05f3",
    x: 110.5,
    y: 495,
    width: 372.8,
    height: 10.25
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    className: "f43665e5-728f-4c4e-9ddf-efdb99fd05f3",
    x: 110.5,
    y: 518.1,
    width: 372.8,
    height: 10.24
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    className: "f43665e5-728f-4c4e-9ddf-efdb99fd05f3",
    x: 110.5,
    y: 541.4,
    width: 372.8,
    height: 10.24
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    className: "f43665e5-728f-4c4e-9ddf-efdb99fd05f3",
    x: 110.5,
    y: 564.7,
    width: 372.8,
    height: 10.25
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "e7749cba-7b26-4614-a9f2-737238dba3f9",
    d: "M634.4,363.5V686.8a28.5,28.5,0,0,1-28.5,28.4H140.7C122.8,715.2,634.4,363.5,634.4,363.5Z",
    transform: "translate(-75.7 -52)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "f8b7cb8f-969f-4585-9d41-90df3a44c739",
    d: "M112.3,363.5V686.8a28.5,28.5,0,0,0,28.4,28.4H605.9C623.9,715.2,112.3,363.5,112.3,363.5Z",
    transform: "translate(-75.7 -52)"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    className: "f3e9da04-6706-4360-be55-d2243af45fe4",
    y: 680.4,
    width: 286,
    height: 18,
    rx: 9
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    className: "f3e9da04-6706-4360-be55-d2243af45fe4",
    x: 298.1,
    y: 680.4,
    width: 62.2,
    height: 18,
    rx: 9
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    className: "f3e9da04-6706-4360-be55-d2243af45fe4",
    x: 376.3,
    y: 680.4,
    width: 193.2,
    height: 18,
    rx: 9
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    className: "f3e9da04-6706-4360-be55-d2243af45fe4",
    x: 192.1,
    y: 713.6,
    width: 276.1,
    height: 18,
    rx: 9
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/email_icon.01b2053592284523893091d7b36172cb.svg";
export { ForwardRef as ReactComponent };